import { DefinedUseQueryResult, useQuery } from '@tanstack/react-query';

import { USER_DETAIL_QUERY_KEYS } from '../queryKeys';
import AccountUserApiV1 from '../../../../../../lib/api/account/user/AccountUserApiV1';
import { setRequestForm } from '../../../../../../lib/common';
import { LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import { QueryOptions } from '../../../../../../types/query/useQuery';
import { AccountUserDetailResponseType } from '../types/accountUserDetail';
import { ACCOUNT_USER_DETAIL_USER_PERSONAL_INFO_MODEL } from '../../AccountUserDetailUserInfo/models';

type UseAccountUserDetailQueryParamsType<SelectResultType> = {
  userId?: number;
  options: QueryOptions<AccountUserDetailResponseType, Error, SelectResultType>;
};
export const useAccountUserDetailQuery = <SelectResultType>(
  props: UseAccountUserDetailQueryParamsType<SelectResultType>,
): DefinedUseQueryResult<SelectResultType, Error> => {
  const { userId, options } = props;
  return useQuery<AccountUserDetailResponseType, Error, SelectResultType>(
    [...USER_DETAIL_QUERY_KEYS.USER_INFO, userId],
    async () => {
      const result = await AccountUserApiV1.getAccountUserDetail(
        setRequestForm(
          {
            userId,
            visitorTimeLine: {
              pagination: LIST_PAGINATION_MODEL,
            },
          },
          true,
        ),
      );
      if ('msg' in result) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: () => ({
        data: {
          /**
           *  유저 기본 정보
           */
          userPersonalInfo: ACCOUNT_USER_DETAIL_USER_PERSONAL_INFO_MODEL,
          /**
           *  디바이스 리스트
           */
          visitorList: [],
          visitorTimeLineList: {
            totalCnt: 0,
            list: [],
          },
        },
      }),
    },
  );
};
